export enum OtoIndividualTransferMethodEnum {
  ALONE = 'ALONE',
  AIRPORT_PICKUP = 'AIRPORT_PICKUP'
}

export const otoIndividualTransferMethodEnumMapping: Record<
  OtoIndividualTransferMethodEnum,
  string
> = {
  [OtoIndividualTransferMethodEnum.ALONE]: 'Arrivée directe dans la famille',
  [OtoIndividualTransferMethodEnum.AIRPORT_PICKUP]: 'Accueil-transfert'
}
